module.exports = __webpack_public_path__ + "static/media/fantest_yps_1.57094092.png";